import React from 'react';
import '../styles/WorkflowsPage.css';

const WorkflowsPage = () => {
  return (
    <div className="workflows-page">
      <div className="wip-container">
        <div className="wip-header">
          <h2>Workflows</h2>
          <div className="wip-badge">Coming Soon</div>
        </div>
        
        <div className="wip-content">
          <div className="doc-preview">
            <div className="workflow-canvas">
              <div className="workflow-node start">
                <div className="node-icon">▶</div>
                <div className="node-label">Start</div>
              </div>
              
              <div className="workflow-connection">
                <div className="connection-line"></div>
                <div className="connection-arrow"></div>
              </div>
              
              <div className="workflow-node prompt">
                <div className="node-icon">💬</div>
                <div className="node-label">Initial Prompt</div>
                <div className="node-content">
                  <div className="line"></div>
                  <div className="line" style={{ width: '70%' }}></div>
                </div>
              </div>
              
              <div className="workflow-connection">
                <div className="connection-line"></div>
                <div className="connection-arrow"></div>
              </div>
              
              <div className="workflow-node process">
                <div className="node-icon">⚙️</div>
                <div className="node-label">Process Response</div>
                <div className="node-content">
                  <div className="line"></div>
                  <div className="line" style={{ width: '60%' }}></div>
                </div>
              </div>
              
              <div className="workflow-connection">
                <div className="connection-line"></div>
                <div className="connection-arrow"></div>
              </div>
              
              <div className="workflow-node condition">
                <div className="node-icon">❓</div>
                <div className="node-label">Condition</div>
                <div className="node-content">
                  <div className="line"></div>
                </div>
              </div>
              
              <div className="workflow-branches">
                <div className="workflow-branch">
                  <div className="branch-connection">
                    <div className="connection-line"></div>
                    <div className="connection-arrow"></div>
                  </div>
                  <div className="workflow-node prompt small">
                    <div className="node-icon">💬</div>
                    <div className="node-label">Follow-up</div>
                  </div>
                </div>
                
                <div className="workflow-branch">
                  <div className="branch-connection">
                    <div className="connection-line"></div>
                    <div className="connection-arrow"></div>
                  </div>
                  <div className="workflow-node output small">
                    <div className="node-icon">📄</div>
                    <div className="node-label">Output</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="wip-info">
            <h3>Workflow Features</h3>
            <ul>
              <li>Chain multiple prompts together</li>
              <li>Conditional branching based on responses</li>
              <li>Process and transform AI outputs</li>
              <li>Save and share reusable workflows</li>
              <li>Integrate with external tools and APIs</li>
            </ul>
            <div className="progress-bar">
              <div className="progress" style={{ width: '45%' }}></div>
            </div>
            <p className="progress-text">Development: 45% Complete</p>
            
            <div className="coming-soon-features">
              <h4>Use Cases</h4>
              <div className="feature-tags">
                <span>Content Creation</span>
                <span>Data Analysis</span>
                <span>Customer Support</span>
                <span>Research</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorkflowsPage; 